module.exports = __webpack_public_path__ + "static/media/Cuadricula_1-gris.7c343b9e.svg";